<template lang="pug">
el-select.prjSelect(
  filterable,
  remote,
  clearable,
  :value="value",
  v-bind="$attrs",
  @input="$emit('input', $event)",
  v-loadMore="getPrjOptions_add",
  :remote-method="projectFilter",
  @change="changeProject",
  @visible-change="tagChange"
)
  el-option-group(v-for="group in allPrjOptions", :key="group.label", :label="group.label")
    el-option.prjStyle(v-for="item in group.options", :key="item.prjId", :label="item.prjName", :value="item.prjId", :title="item.prjName")
</template>

<script>
import { V_FORM_ENUM } from "@/CommonDP/VForm/utils";
import { mapState } from "vuex";
import XtDesignService from "@/CommonDP/service/XtDesign-service";
import { V_FORM_PRJ_ENUM } from "./schema";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: ""
    },
    vFormMode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // prjValue: "", // 下拉框绑定项目
      page: {
        pageNum: 1,
        count: 0,
        totalPage: 1
      }, // 分页
      keyword: "",
      hisOptions: [], // 历史列表
      prjOptions: [] // 项目列表
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    allPrjOptions() {
      const { hisOptions, prjOptions, formatLabelFn } = this;
      const options = [];
      if (hisOptions.length) {
        options.push({
          label: "最近访问",
          options: hisOptions.map(formatLabelFn)
        });
      }
      if (prjOptions.length) {
        options.push({
          label: "项目列表",
          options: prjOptions.map(formatLabelFn)
        });
      }
      return options;
    },
    inputPrjInfo() {
      const { value, allPrjOptions } = this;
      const list = [];
      for (const { options } of allPrjOptions) {
        list.push(...options);
      }
      return list.find(({ prjId }) => value === prjId);
    }
  },
  watch: {
    inputPrjInfo: {
      immediate: true,
      handler(val) {
        const newId = val?.prjId || "";
        const value = this.value || "";
        if (newId === value) {
          this.$emit("changeProject", val);
        }
      }
    }
  },
  mounted() {
    if (this.vFormMode !== V_FORM_ENUM.design) {
      this.getInit();
    }
  },
  methods: {
    formatLabelFn(prjObj) {
      const { format } = this;
      let label = "";
      switch (format) {
        case V_FORM_PRJ_ENUM.format_name:
          label = prjObj.originalPrjName;
          break;

        default:
          label = `${prjObj.prjCode}-${prjObj.originalPrjName}`;
          break;
      }
      return { ...prjObj, prjName: label };
    },
    async getInit() {
      // 最近访问项目 //项目列表
      await Promise.all([this.getHisOptions(), this.getPrjOptions()]);
    },
    // 分页增加
    getPrjOptions_add: _.debounce(async function () {
      const { pageNum, totalPage } = this.page;
      if (Number(pageNum) < Number(totalPage)) {
        const num = Number(pageNum) + 1;
        const params = {
          enterpriseId: this.enterpriseId,
          pageNum: num,
          pageSize: 10,
          keyword: this.keyword
        };
        const res = await XtDesignService.getProjectsByUserIdWithPage(params);
        this.page.count = res.totalCount;
        this.page.pageNum = res.pageIndex;
        this.page.totalPage = res.totalPage;
        this.prjOptions = [...this.prjOptions, ...res.data];
      }
    }, 500),
    // 项目下拉框--弹框显隐
    tagChange(val) {
      if (val === false) {
        this.keyword = "";
        this.getHisOptions();
        this.getPrjOptions();
      }
    },
    // 下拉框切换项目
    async changeProject(prjId) {
      if (prjId) {
        this.tagChange(false);
      }
    },
    // 获得最近访问
    async getHisOptions() {
      const params = {
        enterpriseId: this.enterpriseId,
        businessType: "prj",
        clientType: "web",
        keyword: this.keyword
      };
      const res = await XtDesignService.getUserVisitHistory(params);
      this.hisOptions = res.data;
      this.$store.dispatch("setHisOptions", res.data);
    },
    // 获得项目列表
    async getPrjOptions() {
      this.page = { pageNum: 1, count: 0, totalPage: 1 };
      const params = {
        enterpriseId: this.enterpriseId,
        pageNum: 1,
        pageSize: 10,
        keyword: this.keyword,
        currentPrjId: this.value
      };
      const res = await XtDesignService.getProjectsByUserIdWithPage(params);
      this.page.count = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.page.totalPage = res.totalPage;
      this.prjOptions = res.data;
    },
    // 项目下拉框过滤关键字
    projectFilter(val) {
      this.keyword = val || "";
      this.getHisOptions();
      this.getPrjOptions();
    }
  }
};
</script>

<style lang="scss" scoped>
.prjSelect {
  width: 100%;
}
// .prjStyle{
//   max-width: 300px;
// }
</style>
